import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetTransactionReceipt(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetTransactionReceiptAttempt', handleGetTransactionReceipt, api);
}

function* handleGetTransactionReceipt(api: GoldGateway, action: PayloadAction<{ transactionId: number }>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const { transactionId } = action.payload;
    const response = yield* call([api, api.getTransactionReceipt], {
        authToken,
        transactionId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetTransactionReceiptFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const file = new Blob([response.data], { type: 'text/plain' }); // TODO: later need to change to 'application/pdf'
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Transaction-${transactionId}.txt`);
        document.body.appendChild(link);
        link.click();
        toast.success('Receipt downloaded successfully');
        yield put(combinedActions.goldGetTransactionReceiptSuccess());
    }
}
